import { render } from "./onlineInvoice.vue?vue&type=template&id=2c6dfaae&scoped=true"
import script from "./onlineInvoice.vue?vue&type=script&lang=js"
export * from "./onlineInvoice.vue?vue&type=script&lang=js"

import "./onlineInvoice.vue?vue&type=style&index=0&id=2c6dfaae&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6dfaae"]])

export default __exports__